<div class="mx-auto flex h-16 w-full items-center justify-left text-gray-900 p-2" role="navigation" aria-label="Hauptnavigation">
    <span class="w-full">
        <a [routerLink]="[linkDestination()]"
            class="text-xl text-gray-900! hover:no-underline! font-bold"
            aria-label="Zur Startseite">
            {{ environment.development ? 'Gartenwasserzähler (Test)' : 'Gartenwasserzähler' }}
        </a>
    </span>
    @if(userStateService.isLoggedIn()) {
        <div class="text-xs text-gray-500 flex-col mr-4 justify-items-center" role="status" aria-live="polite">
          <div>Kassenzeichen</div>
          <div class="text-nowrap font-bold">{{ userStateService.userStateSignal().kassenzeichen | mask:'000000-0000-0000' }}</div>
        </div>
        <input type="button" value="Abmelden" class="button-login" (click)="logout()" aria-label="Abmelden" />
    } @else {
        <input type="button" value="Anmelden" class="button-login" (click)="login()" aria-label="Anmelden" />
    }
</div>
